module.exports = __webpack_public_path__ + "media/images/visit-us-header-359d2f232466e9ed3f0d76d948b4c837.jpg";